module.exports = JSON.parse('{"Add Label":"Ajouter une étiquette","Delete measurement":"Supprimer la mesure"}')